import * as Yup from "yup";
import { LoanCalculationType } from "../../../services/eligibilityService/EligibilityService.type";
import {
  FileObject,
  FileStatus
} from "../../../components/formHelpers/FormFileUpload";
import { EligibilityAmountDetailsState } from "./EligibilityAmountFold";

export const eligibilityAmountFoldConstants = {
  buttons: {
    generateOTP: "Generate OTP",
    regenerateOTP: "Re-generate OTP",
    verifyOtp: "Verify OTP",
    submit: "Submit"
  },
  titles: {
    title: "Calculate your loan",
    instantCalculation: "Instant Calculation",
    fileUpload: "File Upload"
  },
  labels: {
    instantCalculationVideoTitle: "Check out this video on instant calculation",
    gstinLoginName: "Enter GSTIN login name",
    gstin: "GSTIN",
    apiAccessHelper: "Learn how to enable API access",
    otp: "Enter OTP",
    gstr1Label: "Upload GSTR1 for 6 months",
    gstr2aLabel: "Upload GSTR2A for 6 months",
    gstr3bLabel: "Upload GSTR3B for 6 months",
    eligibilityInfoNote:
      "Please note that the amount is subject to validation of receivables & KYC.",
    readMore: "Read More",
    mandatory: "*",

    loanTypeOrLabel: "OR",
    instantCalcSecondaryText1: "Instant Result",
    instantCalcSecondaryText2: "Just enter your Login Name",
    manualFileUpload: "Manual File Upload",
    manualFileSecondaryText1: "Takes 10-12 hours",
    manualFileSecondaryText2: "Upload the relevant files yourself",
    intermediateScreenButtonText: "Select",
    intermediateScreenNote: "NOTE: You can switch your preference at any stage",
    insufficientGSTRData:
      "Sorry! We need a minimum of 6 months of GSTR data to provide line credit.",
    manualUploadNote:
      "Instant calculation will not be possible (requires 24 hrs to revert back)",
    eligibilityInProgress: (username: string) =>
      `Hey ${username}, we will reach out to you in next 24 working hours with the in-principle eligibility amount `,
    eligibilityInfo: (username: string) =>
      `Hey ${username}, your in-principle eligibility amount is`,
    eligibilityInfoSuffix: (interestRate: number) =>
      `@${interestRate}% interest Rate and tenure of complete repayment is 4 months.`,
    eligibilityInfoSteps: [
      "Interest Rate is determined using the calculator",
      "Tenure for the GST BillPe product is always 4 months."
    ],
    rejectedPrincipalAmount: (username: string, amount: string) =>
      `Hey ${username}, You have rejected the in-principle eligibility amount of Rs ${amount}.`
  },
  feedback: {
    otpSuccess: "OTP has been successfully sent",
    otpVerifySuccess: "All the documents required has been fetched!",
    filesSubmitted: "Files submitted for verification",
    filesWillBeFetched: "The required files will be fetched"
  },
  consentText: "I agree to JiT Finco's",
  borrowerConsent: 'Borrower Consent Terms',
  termsUse: 'Terms Of Use',
  privacyPolicy:'Privacy Policy'
};

export const GSTR2_SUPPORTED_EXTENSIONS = [".pdf", ".csv", ".xlsx", ".xls"];

// instant loan video link
export const instantCalculationURL = "";

const eligibilityAmountFoldLimits = {
  noOfFiles: 6
};

const errorMessages = {
  required: "Required",
  noOfFiles: `There must be ${eligibilityAmountFoldLimits.noOfFiles} files, one for each month`
};

const gstinFilesValidation = Yup.array<FileObject>().when(
  "loanCalculationType",
  {
    is: LoanCalculationType.manual,
    then: Yup.array<FileObject>()
      .compact(
        (item: FileObject) =>
          item.removed ||
          item.status === (FileStatus.Invalid || FileStatus.Failed)
      )
      .max(eligibilityAmountFoldLimits.noOfFiles, errorMessages.noOfFiles)
      .min(eligibilityAmountFoldLimits.noOfFiles, errorMessages.noOfFiles)
  }
);

export const eligibilityAmountFoldValidationSchema = Yup.object().shape<
  Partial<EligibilityAmountDetailsState>
>({
  gstinLoginName: Yup.string()
    .nullable()
    .when("loanCalculationType", {
      is: LoanCalculationType.instant,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
    }),
  gstr1: gstinFilesValidation,
  gstr2a: gstinFilesValidation,
  gstr3b: gstinFilesValidation
});
